import { render, staticRenderFns } from "./CbxTitle.vue?vue&type=template&id=85ab63fe&"
import script from "./CbxTitle.vue?vue&type=script&lang=ts&"
export * from "./CbxTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports